export type CriterionKey =
  | "market_size"
  | "market_growth"
  | "demand_signal"
  | "entry_opportunity"
  | "monetization"
  | "competition_pressure";

export type CriterionDef = {
  key: CriterionKey;
  label: string;
  short: string;
  description: string;
  selectionTip: string;
  weight: number;
};

export const RESEARCH_CRITERIA: CriterionDef[] = [
  {
    key: "market_size",
    label: "Объём рынка (TAM)",
    short: "Объём",
    description: "Совокупный объём выручки или потенциал ниши в РФ.",
    selectionTip: "Высокий TAM — больше потолок выручки при захвате доли.",
    weight: 0.2,
  },
  {
    key: "market_growth",
    label: "Темп роста рынка",
    short: "Рост",
    description: "Скорость годового роста спроса в нише.",
    selectionTip: "Растущий рынок даёт запас на ошибки в модели на старте.",
    weight: 0.15,
  },
  {
    key: "demand_signal",
    label: "Сигнал спроса",
    short: "Спрос",
    description: "Интерес аудитории: поиск, заявки, продажи.",
    selectionTip: "Спрос подтверждает, что люди ищут решение, а не только СМИ пишут.",
    weight: 0.2,
  },
  {
    key: "entry_opportunity",
    label: "Возможность входа",
    short: "Вход",
    description: "Незанятые ниши и слабые места лидеров (SMB, отрасли).",
    selectionTip: "Ищите дифференциацию в продукте, канале или сегменте.",
    weight: 0.15,
  },
  {
    key: "monetization",
    label: "Монетизация",
    short: "Деньги",
    description: "Средний чек, маржа и устойчивость модели заработка.",
    selectionTip: "Проверьте готовность платить у целевого сегмента.",
    weight: 0.15,
  },
  {
    key: "competition_pressure",
    label: "Давление конкуренции",
    short: "Конкуренция",
    description: "Насыщенность рынка сильными игроками. 10 = слабая конкуренция.",
    selectionTip: "Высокая конкуренция — нужен чёткий УТП, иначе давление на цену.",
    weight: 0.15,
  },
];

export function getCriterionByKey(key: string): CriterionDef | undefined {
  return RESEARCH_CRITERIA.find((c) => c.key === key);
}
